/*
 * bnz-share-link.js — Lien de panier prérempli : ?add=ID:QTE,ID:QTE&promo=CODE
 * ─────────────────────────────────────────────────────────────────────────────
 * Ajoute les variantes au panier existant (sans le remplacer, contrairement aux
 * cart permalinks /cart/ID:QTE qui partent au checkout), applique le code promo
 * en conservant ceux déjà présents, puis affiche la page panier.
 * L'URL est nettoyée d'abord : un rechargement ne doit pas ré-ajouter les produits.
 * Repli uniquement : quand le side cart est actif, bnz-cart-drawer.js gère le lien
 * lui-même (et ouvre le drawer) — on s'efface pour ne pas ajouter deux fois.
 */
(() => {
  if (document.querySelector('bnz-cart-drawer')) return;
  const params = new URLSearchParams(window.location.search);
  const add = params.get('add') || '';
  const promo = (params.get('promo') || '').trim();
  if (!add && !promo) return;

  params.delete('add');
  params.delete('promo');
  const query = params.toString();
  window.history.replaceState(window.history.state, '', `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`);

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const post = (path, body) => fetch(`${root}${path}`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });

  const items = add.split(',').map((part) => {
    const [id, qty] = part.split(':');
    return { id: Number(id), quantity: Math.max(1, parseInt(qty, 10) || 1) };
  }).filter((item) => item.id > 0);

  (async () => {
    try {
      if (items.length) await post('cart/add.js', { items });
      if (promo) {
        // `discount` remplace TOUS les codes du panier : on renvoie la liste complète
        const cart = await (await fetch(`${root}cart.js`, { credentials: 'same-origin' })).json();
        const codes = (cart.discount_codes || []).map((d) => d.code);
        if (!codes.some((c) => c.toLowerCase() === promo.toLowerCase())) {
          await post('cart/update.js', { discount: [...codes, promo].join(',') });
        }
      }
    } catch (err) {
      console.warn('[bnz-share-link]', err.message);
    }
    window.location.replace(`${root}cart`);
  })();
})();
